import { SurveyDispatchReportPage } from './SurveyDispatchReportPage';

export function CsatDispatchReportPage() {
  return (
    <SurveyDispatchReportPage
      surveyType="Csat"
      title="CSAT"
      description="CSAT (Customer Satisfaction) mede a satisfação do cliente com um atendimento específico, em geral após a resolução do chamado. Neste relatório você acompanha cada pesquisa enviada: status do envio, nota, comentários e data da resposta."
      emptyMessage="Nenhuma pesquisa CSAT enviada no período."
      loadErrorMessage="Falha ao carregar o relatório de CSAT."
    />
  );
}
